import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Shield, Book, Mail, MessageCircle, Twitter, Linkedin, Github, BookOpen } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#0A2342] to-[#4ECDC4]/20 text-white mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-2">
              <Home className="w-6 h-6 text-[#4ECDC4]" aria-hidden="true" />
              <span className="text-xl font-bold">
                buyer<span className="text-[#4ECDC4]">View</span>
                <span className="text-sm ml-1 text-[#4ECDC4]">AI</span>
              </span>
            </Link>
            <p className="text-gray-300 text-sm">
              AI-powered property queries you can trust. Helping buyers make informed decisions with verified, moderated property insights.
            </p>
            
            {/* Social Links */}
            <div className="flex space-x-4">
              <a 
                href="https://twitter.com/buyerviewai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-[#4ECDC4] transition-colors"
                aria-label="Follow us on Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a 
                href="https://linkedin.com/company/buyerviewai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-[#4ECDC4] transition-colors"
                aria-label="Connect on LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://github.com/buyerviewai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-[#4ECDC4] transition-colors"
                aria-label="View on GitHub"
              >
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/search" className="text-gray-300 hover:text-[#4ECDC4] transition-colors">
                  Browse Queries
                </Link>
              </li>
              <li>
                <Link to="/add-review" className="text-gray-300 hover:text-[#4ECDC4] transition-colors">
                  Got a Query?
                </Link>
              </li>
              <li>
                <Link to="/verify-location" className="text-gray-300 hover:text-[#4ECDC4] transition-colors">
                  Verify Location
                </Link>
              </li>
              <li>
                <Link to="/auth" className="text-gray-300 hover:text-[#4ECDC4] transition-colors">
                  Sign In
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-[#4ECDC4] transition-colors flex items-center gap-2">
                  <BookOpen className="w-4 h-4" />
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-[#4ECDC4] transition-colors flex items-center gap-2">
                  <MessageCircle className="w-4 h-4" />
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/guidelines" className="text-gray-300 hover:text-[#4ECDC4] transition-colors flex items-center gap-2">
                  <Book className="w-4 h-4" />
                  Query Guidelines
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-[#4ECDC4] transition-colors flex items-center gap-2">
                  <Shield className="w-4 h-4" />
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-[#4ECDC4] transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <a 
                href="mailto:hello@mail.buyerview.ai"
                className="text-gray-300 hover:text-[#4ECDC4] transition-colors flex items-center gap-2"
              >
                <Mail className="w-4 h-4" />
                hello@mail.buyerview.ai
              </a>
              
              <div className="text-gray-300 text-sm">
                <p>Business Hours:</p>
                <p>Mon-Fri: 9AM-6PM AEST</p>
                <p>Response within 24 hours</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-400">
              <p>© {new Date().getFullYear()} buyerView AI. All rights reserved.</p>
            </div>
            
            <div className="flex items-center gap-6 text-sm text-gray-400">
              <span>🇦🇺 Made in Australia</span>
              <span>•</span>
              <span>Powered by AI</span>
              <span>•</span>
              <span>GDPR Compliant</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}